import React from 'react';
import { Link } from 'react-router-dom';

export function StyledLink({
  label,
  linkText,
  to
}: {
  to: string;
  label?: string;
  linkText: string;
}) {
  return (
    <div className="flex flex-row justify-center my-2 text-sm">
      <span className="text-sm text-neutral-400 font-light">{label}</span>
      &nbsp;
      <Link className="link link-sm font-semibold" to={to}>
        {linkText}
      </Link>
    </div>
  );
}
